<template>
  <div class="wrapper">
    <p class="title text-center">Deactivate My Account</p>
    <div class="content">
      <!-- confirmation message  -->
      <p class="confirmation-title">
        Are you sure you want to <b>“Deactivate”</b> your account?
      </p>
      <p class="confirmation-body" v-html="confirmationBody"></p>
      <!-- current password  -->
      <p class="password-label">Please enter your current password.</p>
      <div class="current-password-wrapper">
        <div class="form-group m-d-gruop" :class="{'invalid-value' : invalidPassword}">
          <b-form-input id="password" type="password" v-model="password" required  @input="changePassword"/>
          <label for="password">Password</label>
        </div>
        <div v-if="invalidPassword" class="err-wrapper"> Password is incorrect.</div>

        <span @click="showPasswordVal()" class="showPassword"  :class="{'mt-71' : invalidPassword}">
          <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0C5.18182 0 1.49409 2.69533 0 6.5C1.49409 10.3047 5.18182 13 9.5 13C13.8182 13 17.5059 10.3047 19 6.5C17.5059 2.69533 13.8182 0 9.5 0ZM9.5 10.8332C7.11636 10.8332 5.18182 8.89184 5.18182 6.49984C5.18182 4.10784 7.11636 2.1665 9.5 2.1665C11.8836 2.1665 13.8182 4.10784 13.8182 6.49984C13.8182 8.89184 11.8836 10.8332 9.5 10.8332ZM6.90909 6.4999C6.90909 5.06124 8.06636 3.8999 9.5 3.8999C10.9336 3.8999 12.0909 5.06124 12.0909 6.4999C12.0909 7.93857 10.9336 9.0999 9.5 9.0999C8.06636 9.0999 6.90909 7.93857 6.90909 6.4999Z" :fill="colorVal"/>
          </svg>
        </span>
      </div>

    </div>
    <!-- action btns  -->
    <hr class="h-line"/>
    <div class="action-btns">
      <button class="submit-btn btn btn-primary" size="md"  @click="$bvModal.hide('deactiveAccount')">
        Cancel
      </button>
      <button class="btn btn-outline-danger" @click="onSubmit" :disabled="getDeactivateLoading || invalidPassword || !password">
        <i v-if="getDeactivateLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
        <span v-else>Deactivate</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["loggedInUser"],
  data() {
    return {
      submitted: false,
      userId : null,
      password: "",
      confirmationBody : '',
      colorVal: '#787878',
      invalidPassword : false,
    };
  },
  computed: {
    ...mapGetters("user", ["getDeactivateLoading", "getUserData"]),
  },
  methods: {
    ...mapActions("user", ["deactivateAccount"]),
    changePassword(){
      this.invalidPassword = false;
    },
    showPasswordVal(){
      const passwordField = document.getElementById('password');
      if (passwordField.type === "password") {
        passwordField.type = "text";
        this.colorVal = '#103F5E'
      } else {
        passwordField.type = "password";
        this.colorVal = '#787878'
      }
    },
    onSubmit() {
      this.submitted = true;
      this.deactivateAccount({
        password: this.password,
        id : this.getUserData.id,
      }).then((res) => {
        console.log('res', res);
      }).catch((e) =>{
        console.log('e',e);
        this.submitted = false;
        this.invalidPassword = true;
      })
    },
  },
  beforeMount(){
    if( this.getUserData && this.getUserData.is_system_user){
      this.confirmationBody = 'Your account will be deleted permenantly after 30 days and thus you will be revoked from all the dashboards you have access to. You can cancel the deactivation process by logging into your account again within the 30 days.'
    }else {
      this.confirmationBody = 'Your account will be deleted permenantly after 30 days. You can cancel the deactivation process by logging into your account again within the 30 days.'
    }
  }
};
</script>

<style lang="scss">
div#deactiveAccount___BV_modal_content_ {
  .wrapper {
    .form-group{
      margin-bottom: 0px;
    }
    .confirmation-body {
      text-align: center;
      color: #4A4A4A;
      font-weight: 400;
      font-size: 16px;
      margin-bottom: 29px;
    }
    .confirmation-title {
      font-family: Lato;
      font-size: 16px;
      font-weight: 400;
      line-height: 19.2px;
      letter-spacing: 0.25px;
      text-align: center;
      color: #4A4A4A;

    }
    .password-label {
      font-family: Lato;
      font-size: 16px;
      font-weight: 400;
      line-height: 19.2px;
      letter-spacing: 0.25px;
      text-align: center;
      color: #4A4A4A;
    }
    .err-wrapper {
      margin-top: 8px;
    }
    .current-password-wrapper {
      margin-bottom: 25px;
      .input-wrapper {
        padding: 0 38px !important;
      }
    }
    .h-line {
      margin-top: 40px !important;
      margin-bottom: 24px !important;
    }
  }
  .m-d-gruop > input {
    width: 90%;
  }
  .mt-71{
    margin-top:-71px
  }
}
</style>
